import { render } from "./BlogContent.vue?vue&type=template&id=738fbcd6&scoped=true"
import script from "./BlogContent.vue?vue&type=script&lang=js"
export * from "./BlogContent.vue?vue&type=script&lang=js"

import "./BlogContent.vue?vue&type=style&index=0&id=738fbcd6&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738fbcd6"]])

export default __exports__